/**
 * Handles variables for transporter
 */
export default class TransporterVariables {
	/**
	 * Public constructor
	 * @param {Object} options
	 */
	constructor(options, mainController) {
		this.mainController = mainController;
		this.variableList = this._initVariableList(options);
	}

	/**
	 * Get initialized list of document variables
	 * @param {string[]} options
	 */
	_initVariableList(options) {
		let variableList = {};
		let variableNames = [];
		// If the variables were passed in from options
		if (options.attributes.document_variables) {
			variableNames = options.attributes.document_variables;
		}
		// If the variables are in AoPS.bd (edit view)
		else if (
			AoPS.bd.document_version &&
			AoPS.bd.document_version.document_variables
		) {
			variableNames = AoPS.bd.document_version.document_variables;
		}

		// Set each variable to null
		if (variableNames) {
			$.each(variableNames, (index, value) => {
				variableList[value] = null;
			});
		}

		return variableList;
	}

	/**
	 * Gets the current variable list
	 * @returns Object
	 */
	getVariableList() {
		return this.variableList;
	}

	/**
	 * Reset the variables to null
	 */
	resetVariables() {
		// Reset variables
		$.each(this.variableList, (key, value) => {
			this.variableList[key] = null;
		});
	}

	/**
	 * Save the value to the variable
	 * @param {string[]} options
	 * @param {string} varName
	 * @param {string} varVal
	 */
	setValue(varName, varVal) {
		// Evaulate variables and formulas
		varVal = this.mainController.transporterVariables.processValue(varVal);

		// Process RAND function
		varVal = this.processRand(varVal);

		// Save it in the list
		this.variableList[varName] = varVal;

		// Update the variable in the debug view
		this.mainController.debugger.setVariable(varName);
	}

	/**
	 * Replace any variables and evaluate as a formula
	 * @param {string} varVal
	 * @returns
	 */
	processValue(varVal) {
		// Define return value defaulted to original
		var retVal = varVal;

		// Only parse these if they have variables in them, so we don't process normal formulas
		if (varVal.indexOf("{{") !== -1) {
			// Replace any variables with thier values
			varVal = this.replaceVariablesText(varVal);

			// Store retVal with variables processed before trying to execute formula
			retVal = varVal;

			// Check that this only has numbers and basic math operations
			const validChars = "[0-9+\\-*%^&|!/=><\\s().]*";
			const functions =
				"(toPrecision|Math\\.ceil|Math\\.floor|RAND\\((\\d+),(\\d+)\\))";
			const regex = new RegExp(
				`^${validChars}${functions}?${validChars}${functions}?${validChars}${functions}?${validChars}$`
			);

			if (regex.test(varVal)) {
				try {
					// Javascript is weird and uses ** for exponents
					varVal = varVal.replace("^", "**");

					// Handle random numbers
					varVal = this.processRand(varVal);

					// Execute the function to get its value
					retVal = new Function(`return (${varVal})`)();
				} catch (error) {
					// If it doesn't evaluate just return original value
					retVal = varVal;
				}
			}
		}
		return retVal;
	}

	/**
	 * Look for RAND(x,y) and replace it with a random number
	 * @param {*} text
	 */
	processRand(text) {
		let response = text;
		if (typeof text.replace === "function") {
			response = text.replace(/RAND\((\d+),(\d+)\)/g, (match, x, y) => {
				const min = parseInt(x);
				const max = parseInt(y);
				const rand = Math.random();
				return Math.floor(rand * (max - min + 1)) + min;
			});
		}
		return response;
	}

	/**
	 * Look for variables in a string and replace them with the value
	 * @param {string} text
	 * @returns {string}
	 */
	replaceVariablesText(text) {
		// Look for variables in the text, ie {{x}}
		const regex = /{{(.*?)}}/g;
		const matches = [];
		let match;
		while ((match = regex.exec(text)) !== null) {
			matches.push(match[1]);
		}

		// If we found any matches replace them
		if (matches.length > 0) {
			$.each(matches, (key, val) => {
				if (this.variableList.hasOwnProperty(val)) {
					const searchVal = "{{" + val + "}}";
					const replaceVal = this.variableList[val];
					text = text.replace(searchVal, replaceVal);
				}
			});
		}

		return text;
	}
}
